module.exports = __webpack_public_path__ + "static/media/fortenergy.fbc82fa4.png";